import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { crm } from '../../../store/cabinetApi/crm';
import { skipToken } from '@reduxjs/toolkit/query';
import { AnalyticsEvent } from '../../../store/cabinetApi/generated/analytics';
import { EventBrief } from '../../../store/cabinetApi/generated/crm';
import { RootState, ThunkDispatchType } from '../../../store';
import { actions } from '../../../store';
import EventDetailModal from './EventDetailModal';

interface EventDetailModalContainerProps {
  open: boolean;
  onClose: () => void;
  event: AnalyticsEvent | null;
}

const EventDetailModalContainer = ({ open, onClose, event }: EventDetailModalContainerProps) => {
  const dispatch = useDispatch<ThunkDispatchType>();
  const user = useSelector((state: RootState) => state.auth.user);
  const meeting = useSelector((state: RootState) => 
    event?.meeting ? state.schedule.meetings[event.meeting] : null
  );

  const { data: briefData, isLoading: isLoadingBrief } = crm.useAppCrmEventBriefsRetrieveQuery(
    event?.event_idr ? event.event_idr : skipToken
  );

  const [updateBrief, { isLoading: isUpdatingBrief }] = crm.useAppCrmEventBriefsPartialUpdateMutation();

  // Fetch meeting data when event changes and has a meeting ID
  useEffect(() => {
    if (event?.meeting && !meeting) {
      dispatch(actions.schedule.fetchMeeting(event.meeting.toString()));
    }
  }, [event?.meeting, meeting, dispatch]);

  const handleUpdateBrief = async (updatedBrief: Partial<EventBrief>) => {
    if (!event?.event_idr) return;
    
    await updateBrief({
      eventUniqueId: event.event_idr,
      patchedEventBrief: updatedBrief
    });
  };

  const briefNotFound = !isLoadingBrief && !briefData;

  return (
    <EventDetailModal
      open={open}
      onClose={onClose}
      event={event}
      briefData={briefData}
      briefLoading={isLoadingBrief}
      briefNotFound={briefNotFound}
      isUpdatingBrief={isUpdatingBrief}
      onUpdateBrief={handleUpdateBrief}
      userHasBriefFeature={!!user?.features.MEETING_BRIEFS}
    />
  );
};

export default EventDetailModalContainer; 